var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 5H10.5C9.17392 5 7.90215 5.52678 6.96447 6.46447C6.02678 7.40215 5.5 8.67392 5.5 10V30C5.5 31.3261 6.02678 32.5979 6.96447 33.5355C7.90215 34.4732 9.17392 35 10.5 35H30.5C31.8261 35 33.0979 34.4732 34.0355 33.5355C34.9732 32.5979 35.5 31.3261 35.5 30V10C35.5 8.67392 34.9732 7.40215 34.0355 6.46447C33.0979 5.52678 31.8261 5 30.5 5ZM10.5 8.33333H30.5C30.942 8.33333 31.366 8.50893 31.6785 8.82149C31.9911 9.13405 32.1667 9.55797 32.1667 10V23.9333L26.8333 19.3833C26.007 18.7034 24.9701 18.3317 23.9 18.3317C22.8299 18.3317 21.793 18.7034 20.9667 19.3833L8.83333 29.5V10C8.83333 9.55797 9.00893 9.13405 9.32149 8.82149C9.63405 8.50893 10.058 8.33333 10.5 8.33333ZM30.5 31.6667H11.4333L23.1 21.9333C23.3241 21.7669 23.5959 21.6771 23.875 21.6771C24.1541 21.6771 24.4259 21.7669 24.65 21.9333L32.1667 28.3333V30C32.1667 30.442 31.9911 30.866 31.6785 31.1785C31.366 31.4911 30.942 31.6667 30.5 31.6667Z",
    fill: "#C2C4C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8335 16.6665C15.2142 16.6665 16.3335 15.5472 16.3335 14.1665C16.3335 12.7858 15.2142 11.6665 13.8335 11.6665C12.4528 11.6665 11.3335 12.7858 11.3335 14.1665C11.3335 15.5472 12.4528 16.6665 13.8335 16.6665Z",
    fill: "#C2C4C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon_image.283bfbd4623c61e959a77a60869e8222.svg";
export { ForwardRef as ReactComponent };